import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './App.css';
import './components/Header.css';
import './components/MainContent.css';
import './components/Footer.css';
import './components/AboutUs.css';
import './components/GetInTouch.css';
import './components/ProductBreads.css';
import App from './App';
import { RecoilRoot } from 'recoil';

ReactDOM.render(
  <React.StrictMode>
    <RecoilRoot>
        <App />
    </RecoilRoot>
  </React.StrictMode>,
  document.getElementById('root')
);